export enum SearchType {
    Contains = 1,
    Equals = 2,
    StartsWith = 3,
    EndsWith = 4,
}

export enum GetProductsSearchOptionType {
    Name = 1,
    Description = 2,
    Upc = 3,
    Brand = 4,
    // The API rejects it with a 400 (#408): a product's vendors are many, so
    // there is no single vendor to match. Kept so the ints stay aligned.
    Vendor = 5,
}

export enum GetProductsSortOptionType {
    Id = 1,
    Name = 2,
    Description = 3,
    Upc = 4,
    // The API rejects it with a 400 (#408): a product's vendors are many, so
    // there is no single vendor to sort by. Kept so the ints stay aligned.
    Vendor = 5,
    Brand = 6,
    // The base sku's price (GetProductsQuery.SortExpressions).
    Price = 7,
}

export enum SortDirectionType {
    Asc = 1,
    Desc = 2,
}

export interface GetProductsQuery {
    pageNumber?: number;
    pageSize?: number;
    search?: string;
    searchType?: SearchType;
    searchBy?: GetProductsSearchOptionType[];
    sortBy?: GetProductsSortOptionType[];
    sortDirection?: SortDirectionType;
    categoryId?: number;
    tags?: string[];
    includeInactive?: boolean;
}

export const DEFAULT_PRODUCTS_QUERY: GetProductsQuery = {
    pageNumber: 1,
    pageSize: 25,
    search: '',
    searchType: SearchType.Contains,
    searchBy: [GetProductsSearchOptionType.Name],
    sortBy: [GetProductsSortOptionType.Id],
    sortDirection: SortDirectionType.Asc,
    includeInactive: false,
    tags: [],
};
